export const main = {
  consumer_notice: 'If you are a consumer wanting to order food instead, visit our marketplace',
  consumer_notice_mobile: 'Consumer who wants to order food?',
  order_now: 'Order now',
  order_food: 'Order food',

  logo_alt: 'Bistroo',
  login_text: 'Log in',
  start_free_text: 'Start free',

  actions: {
    create_your_shop: 'Create your shop',
    product_demo: 'Product demo'
  },
  menu: {
    home: {
      text: 'Home',
    },
    products: {
      text: 'Products',
      submenu: {
        manager: {
          text: 'Bistroo Manager',
          subtext: 'All the tools you need to manage'
        },
        qr: {
          text: 'Bistroo QR',
          subtext: 'Cost-efficient table ordering'
        },
        webshop: {
          text: 'Bistroo Webshop',
          subtext: 'Easy to setup restaurant webshop'
        },
        pos: {
          text: 'Bistroo POS Device',
          subtext: 'Plug & play order and print',
        },
        page: {
          text: 'Bistroo Page',
          subtext: 'Create a website in minutes'
        }
      }
    },
    prices: {
      text: 'Pricing',
    },
    cases: {
      text: 'Cases',
      submenu: {
        cafetaria: {
          text: 'Cafetaria D\'n Boom',
          subtext: 'How bistroo helped grow revenue',
        },
        grillroom: {
          text: 'Grillroom Instanbul',
          subtext: 'Finally a fair revenue model',
        },
        sushi: {
          text: 'Sushi De wethouder',
          subtext: 'A partner that we can trust 24/7'
        },
        italian: {
          text: 'Italian restaurant Il Municipio',
          subtext: 'A new solution and possibilities'
        },
        lunchroom: {
          text: 'Lunchroom Two-B',
          subtext: 'We saved a lot of time and frustration'
        },
      }
    },
    info: {
      text: 'Info',
      submenu: {
        helpcenter: {
          text: 'Helpcenter',
          subtext: 'All the information you need',
        },
        integrations: {
          text: 'Integrations',
          subtext: 'Our partner integrations',
        },
        downloads: {
          text: 'Downloads',
          subtext: 'The latest app updates',
        },
        articles: {
          text: 'Articles',
          subtext: 'Latest industry updates',
        },
        faq: {
          text: 'FAQ',
          subtext: 'Frequently asked questions',
        },
        support: {
          text: 'Customer support',
          subtext: 'Get in touch',
        },
      }
    },
  },
  cta_block: {
    open_your_webshop_today: 'Open your webshop today.',
    its_free: 'It\'s free!',
    start_generating_more_orders: 'Start generating more orders within minutes',
get_started_for_free: 'Get started free'
  },
  footer: {
    general: 'General',
    products: 'Products',
    cases: 'Cases',
    info: 'Information'
  }
}